import { render, staticRenderFns } from "./VideoStep.vue?vue&type=template&id=0f0bb37e&scoped=true&"
import script from "./VideoStep.vue?vue&type=script&lang=js&"
export * from "./VideoStep.vue?vue&type=script&lang=js&"
import style0 from "./VideoStep.vue?vue&type=style&index=0&id=0f0bb37e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0bb37e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
installComponents(component, {VAlert,VBtn,VIcon,VImg,VResponsive})
